import React from 'react'
import Select from 'react-select'
import { Controller } from 'react-hook-form'

import './address_element.scss'

const AddressSelectElement = ({ control, options }) => {
  return (
    <div className="address-element-container">
      <Controller
        name='select_address'
        control={control}
        render={({ field }) => <Select 
          {...field}
          classNamePrefix='address-select'
          options={options}
          onChange={(value) => {
            field.onChange(value)
          }}
        />}
      />
    </div>
  )
}

export const AddressElement = ({ control, label, options }) => {
  return (
    <div className="form-item-address delivery-address mb-3">
      {label && (
        <label className="mb-2">{label}</label>
      )}
      <AddressSelectElement 
        control={control} 
        options={options} />
    </div>
  )
}
